import Hero from "components/organisms/common/Hero"
import ImageUkHero from "components/atoms/schools/ImageUkHero"
import useTranslations from "hooks/useTranslations"
import BookDemoButton from "./BookDemoButton"

/**
 * Mint hero, matching the UK sales deck's cover — the deck's mint is
 * rgb(96,202,178) and `kkm-green` resolves to rgb(91,200,180), so the brand
 * token already is the deck colour.
 *
 * The brand word is picked out in cream rather than underlined. Note that no
 * light colour can reach WCAG's 3:1 for large text against this mint — white
 * itself only manages 2:1 — so the emphasis here is carried by hue, with the
 * surrounding words in near-black doing the legibility work. That is the same
 * trade the site's yellow heroes already make with their white highlights.
 *
 * Not flipped. The children in the photo look down and to the left, which on
 * this layout points them back at the headline; mirroring them would have them
 * looking off the edge of the page.
 */
export default function UkHero() {
  const {
    ukSchoolsHeroTitle,
    ukSchoolsHeroDescription,
    ukSchoolsHeroHighlight,
    ukSchoolsHeroButton,
  } = useTranslations()

  return (
    <Hero
      Image={ImageUkHero}
      slides={[ukSchoolsHeroTitle]}
      description={ukSchoolsHeroDescription}
      bgColor="green"
      flipImage={false}
      searchWords={ukSchoolsHeroHighlight || [""]}
      highlightClassName="bg-transparent text-kkm-cream"
      Button={() => (
        <BookDemoButton label={ukSchoolsHeroButton} bgStyle="black" />
      )}
    />
  )
}
